export enum ThirdPartyServiceName {
  GOOGLE_TAG_MANAGER = 'google-tag-manager',
}

export type ThirdPartyService = {
  id: ThirdPartyServiceName; // Vendor id from Didomi
  type: string;
  initialized: boolean;
  init: () => void;
  disable: () => void;
};

export const thirdPartyServices: ThirdPartyService[] = [
  {
    id: ThirdPartyServiceName.GOOGLE_TAG_MANAGER,
    type: 'analytics',
    initialized: false,
    init: function () {
      if (!process.env.NEXT_PUBLIC_GTM_ID) {
        console.warn('google-tag-manager: mising GTM id...');
        return;
      }

      if (this.initialized) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      // Checking for existing gtm script element
      const existingScriptElement = document.getElementById('gtm-loader');
      if (existingScriptElement) {
        this.initialized = true;
        return;
      }

      // Prepare script tag so as to load gtm
      const lastScriptElement = document.getElementsByTagName('script')[0];
      const scriptElement = document.createElement(
        'script',
      ) as HTMLScriptElement;
      scriptElement.id = 'gtm-loader';
      scriptElement.async = true;
      scriptElement.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GTM_ID!}`;
      scriptElement.onload = () => {
        this.initialized = true;
      };

      lastScriptElement.parentNode?.insertBefore(
        scriptElement,
        lastScriptElement,
      );
    },
    disable: function () {
      // Find a way to flush datalayer or remove GTM script
      window.dataLayer?.push({ event: 'didomi_consent_revoked' });

      this.initialized = false;
    },
  },
];
